import { writable } from 'svelte/store';

function createFormValues() {
    const { subscribe, set } = writable({})

    return {
        subscribe,
        set,
        reset: () => set({}),
    }
}

export const formValues = createFormValues();
